import type { MembershipPurchaseGateway } from '../api/MembershipPurchaseGateway';
import type {
  MembershipPurchaseEvent,
  MembershipPurchaseIncident,
} from '../domain/purchase';
import type { CardFormFactory } from '../payment/CardForm';
import type { MembershipMarkers } from './MembershipMarkers';

/** Step of a purchase in Join. */
export type MembershipPurchasePhase =
  | 'idle'
  | 'form'
  | 'submitting'
  | 'challenge'
  | 'confirming'
  | 'reconciling';

/** Where Join sends the customer once the purchase is settled. */
export type MembershipPurchaseExit = 'member' | 'activating';

/** Everything the purchase store needs from the outside world. */
export interface MembershipPurchaseStoreDeps {
  gateway: MembershipPurchaseGateway;
  createCardForm: CardFormFactory;
  markers: MembershipMarkers;
  /** Absolute `returnUrl` for a redirect 3DS: Join on the club page, whatever the plan. */
  returnUrl: () => string;
  /** The backend's membership may have changed; re-read it. */
  onMembershipChanged: () => void;
  /** The backend no longer knows the plan; re-read the zone's plans. */
  onPlansStale: () => void;
  /** Reloads the page; the only retry for a card form whose code never arrived. */
  reloadPage: () => void;
  track: (event: MembershipPurchaseEvent) => void;
  report: (incident: MembershipPurchaseIncident) => void;
}

/** Phases in which a request is in flight or its outcome is being checked. */
export const BUSY_PHASES: ReadonlySet<MembershipPurchasePhase> = new Set([
  'submitting',
  'confirming',
  'reconciling',
]);
